import DialogContentText from '@mui/material/DialogContentText';
import { ButtonRounded } from '@Calix-Commerce/design-system';

import { Dialog, DialogTitle, DialogContent, DialogActions } from './styledComponents';

export type ModalProps = {
  isOpen: boolean;
  modalContent: React.ReactNode;
  onCancel: () => void;
  onConfirmation: () => void;
  onDiscard: () => void;
};

const UnsavedChangesModal = ({
  isOpen = false,
  onCancel,
  onConfirmation,
  onDiscard,
  modalContent,
}: ModalProps) => {
  return (
    <Dialog
      id="modal"
      open={isOpen}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      position={'center'}
    >
      <DialogTitle id="alert-dialog-slide-title">Unsaved Changes</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">{modalContent}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonRounded id="cancel-btn" colorVariant="tertiary" onClick={onCancel}>
          CANCEL
        </ButtonRounded>
        <ButtonRounded id="confirm-btn" onClick={onDiscard}>
          DISCARD CHANGES
        </ButtonRounded>
        <ButtonRounded id="confirm-btn" onClick={onConfirmation}>
          SAVE CHANGES
        </ButtonRounded>
      </DialogActions>
    </Dialog>
  );
};

export { UnsavedChangesModal };
